import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

export default function useIsCurrentLinkCallBack() {
	const { pathname: currentPathname } = useLocation()

	const executeCurrentLink = useCallback(
		(pathname: string) => {
			const base = pathname

			let isCurrent = false

			if (base === '/') {
				isCurrent = currentPathname === '/'
			} else {
				isCurrent =
					currentPathname === base || currentPathname.startsWith(`${base}/`)
			}

			return isCurrent
		},
		[currentPathname]
	)

	return { executeCurrentLink }
}
